<template>
  <div class="user-menu" v-if="loggedIn">
    <v-menu
      v-model="showUserMenu"
      v-show="!breakpoint.xsOnly"
      origin="top right"
      :close-on-content-click="true"
      offset-y
      nudge-bottom="16"
    >
      <v-btn slot="activator" icon dark>
        <!-- <v-icon>account_circle</v-icon> -->
        <v-avatar size="34">
          <img :src="getProfilePictureURL" :alt="user.displayName" />
        </v-avatar>
      </v-btn>

      <v-card>
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <img :src="getProfilePictureURL" :alt="user.displayName" />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ user.displayName }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>
        <v-list>
          <v-list-tile to="/account/" active-class>
            <v-list-tile-action>
              <v-icon>person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Account</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile to="/settings/" active-class>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Settings</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>

        <v-list>
          <v-list-tile @click="logOutUser">
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Log Out</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>

    <!-- Account Menu  mobile  dialog -->

    <v-dialog v-model="accountDialogMobile" persistent :fullscreen="true">
      <template v-slot:activator="{ on }">
        <v-btn v-show="breakpoint.xsOnly" icon dark v-on="on">
          <v-avatar size="34">
            <img
              :src="getProfilePictureURL"
              :alt="getProfilePictureURL"
            />
          </v-avatar>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dense flat color="grey darken-3" dark>
          <v-toolbar-title>Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="accountDialogMobile = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <img
                :src="getProfilePictureURL"
                :alt="getProfilePictureURL"
              />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ user.displayName }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>
        <v-list>
          <v-list-tile to="/account/" @click="accountDialogMobile = false" active-class>
            <v-list-tile-action>
              <v-icon>person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>User Account</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile to="/settings/" @click="accountDialogMobile = false" active-class>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Settings</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>

        <v-list>
          <v-list-tile @click="logOutUser">
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Log Out</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "firebase/app";
export default {
  name: "UserMenu",
  data() {
    return {
      accountDialogMobile: false,
      // user: null
    };
  },
  methods: {
    logOutUser() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch('setSnackbar', {
            timeout: 3000,
            text: 'You have logged out'
          });
          console.log("You have signed out");
          this.accountDialogMobile = false;
          this.$router.push("/").catch(() => {});
        });
    },
  },
  computed: {
    // user() {
    //   console.log(firebase.auth().currentUser);

    //   return firebase.auth().currentUser;
    // },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    loggedIn() {
      return this.$store.getters.getUser;
    },
    showUserMenu: {
      get() {
        return this.$store.getShowUserMenu;
      },
      set(value) {
        this.$store.dispatch("setShowUserMenu", value);
      },
    },
    getProfilePictureURL() {
      if (this.$store.getters.getUserObject.photoURL) {
        return firebase.auth().currentUser.photoURL + '?access_token=' + this.$store.state.accessToken;
        //return this.$store.getters.getUserObject.photoURL;
        // return firebase.auth().currentUser.photoURL;
      } else {
        return "images/standard-profile-picture50x50.png";
      }
    },
    getDisplayName() {
      return firebase.auth().currentUser.displayName;
    },
    user() {
      if (this.$store.getters.getUserObject) {
        return this.$store.getters.getUserObject;
      } else {
        return null;
      }
    }
  }
};
</script>

<style>
</style>